import querystring from 'querystring';

export const queryParamToString = (params?: Record<string, any>) => {
  const queryParams = querystring.stringify(
    Object.fromEntries(
      Object.entries(params ?? {}).filter(
        ([_, value]) => value !== '' && value !== undefined && value !== null
      )
    )
  );

  return queryParams;
};

export const formatRupiah = (amount?: number) => {
  const isNegative = (amount ?? 0) < 0;
  const absoluteAmount = Math.abs(amount ?? 0);

  const formatted = absoluteAmount
    .toString()
    .split('')
    .reverse()
    .map((digit, index) => (index > 0 && index % 3 === 0 ? `${digit}.` : digit))
    .reverse()
    .join('');

  return `${isNegative ? '-' : ''}IDR ${formatted}`;
};

export function copyWith<T>(params: T, updates: Partial<T>): T {
  return {
    ...params,
    ...updates,
  };
}

export const validateUrlParams = (
  params: Record<string, string>,
  requiredParams: string[]
): boolean =>
  requiredParams.every((param) => {
    const exists = params[param] !== undefined && params[param] !== '';
    return exists;
  });

export const generateBookingCode = () => {
  const now = new Date();
  const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Month (01-12)
  const day = now.getDate().toString().padStart(2, '0'); // Day (01-31)

  // Generate random 4 digit number
  const randomDigits = Math.floor(Math.random() * 10000)
    .toString()
    .padStart(4, '0');

  return `PJ${year}${month}${day}${randomDigits}`;
};

export const formatTimeDifference = (endTime: Date | string): string => {
  const end = new Date(endTime);
  const now = new Date();

  const diffInMinutes = Math.floor((end.getTime() - now.getTime()) / (1000 * 60));

  if (diffInMinutes <= 0) {
    return '0 menit';
  }

  const hours = Math.floor(diffInMinutes / 60);
  const minutes = diffInMinutes % 60;

  if (hours > 0) {
    return `${hours} jam ${minutes > 0 ? `${minutes} menit` : ''}`.trim();
  }

  return `${minutes} menit`;
};

export interface TimeLeft {
  hours: string;
  minutes: string;
  seconds: string;
}

export const calculateTimeLeft = (endTime: string | Date): TimeLeft => {
  const end = new Date(endTime);
  const now = new Date();
  const diff = end.getTime() - now.getTime();

  if (diff <= 0) {
    return {
      hours: '00',
      minutes: '00',
      seconds: '00',
    };
  }

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  };
};
